import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { rmOpApi, rmPdDtlApi } from "components/api/book";
import { successControl } from "util/commAction";
import { useEffect, useRef, useState } from "react";
import { IRmOp, IRmPd } from "interface/book";
import Package from "./package";
import room from "assets/icon/icon_room.png";
import group from "assets/icon/icon_group.png";
import Slider from "components/slider";
import proImage from "assets/image/book_dflt_prd_item.png";
import { useBookInfContext } from "components/context/bookInfContext";
import Loading from "components/layout/loading";
import "./detail.scss";

type IProps = {
  rmPdNo: string;
};

export default function RmDetail({ rmPdNo }: IProps) {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const { bookInf } = useBookInfContext();
  const [rmPdInf, setRmPdInf] = useState<Pick<IRmPd, "rmPdInf"> | any>();
  const [rmImgList, setRmImgList] = useState<any>([]);
  const [rmOpList, setRmOpList] = useState<any>([]);
  const [lodOpList, setLodOpList] = useState<any>([]);
  const rmDescRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLogin] = useState(true);

  const [packageList, setPackageList] = useState<IRmOp[]>([]);

  //패키지 조회
  const packageMutation = useMutation({
    mutationFn: rmOpApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;
        successControl({
          status,
          success() {
            setPackageList(data.rmOpList);
            setIsLogin(false);
          },
        });
      }
    },
  });

  //객실상세 조회
  const rmDtlMutation = useMutation({
    mutationFn: rmPdDtlApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            setLodOpList(res.data.lodOpList);
            setRmPdInf(res.data.rmPdInf);
            setRmImgList(res.data.rmImgList);
            setRmOpList(res.data.rmOpList);
            if (rmDescRef.current) {
              rmDescRef.current.innerHTML = res.data.rmPdInf?.rmDesc;
            }
          },
        });
      }
    },
  });

  useEffect(() => {
    if (!!rmPdNo) {
      rmDtlMutation.mutate({ rmPdNo });
    }
  }, []);

  useEffect(() => {
    if (bookInf && rmPdInf) {
      const { rmCnt, adltCnt, childCnt, dates } = bookInf;
      const params = {
        lodNo: rmPdInf?.lodNo,
        rmNo: rmPdInf?.rmNo,
        resvSDt: dates[0],
        resvEDt: dates[1],
        resvRmCt: rmCnt,
        adltPerCt: adltCnt,
        chldPerCt: childCnt,
      };

      packageMutation.mutate(params);
    }
  }, [rmPdInf]);

  return (
    // <BookInfProvider>
    <div className="rm-detail">
      <h3 className="flex-1 wrap-text">{rmPdInf?.rmNm}</h3>
      {/* 이미지 슬라이드 */}
      {/* <div>이미지 슬라이드</div> */}
      {rmImgList.length === 0 && (
        <img
          src={proImage}
          alt=""
          onError={(e) => {
            if (e.type === "error") {
              e.currentTarget.src = proImage;
            }
          }}
        />
      )}

      {rmImgList.length !== 0 && <Slider rmImgList={rmImgList} />}

      {/* 객실소개 */}
      <div className="mt-6 md:mt-10">
        <h4>{t("sb_ttl_md_itr_bk")}</h4>
        <ul className="">
          <li>
            <img is-icon="true" src={room} alt="객실아이콘" />
            <span data-icon="room" className="wrap-text">
              {rmPdInf?.rmNm}
            </span>
          </li>
          <li>
            <img is-icon="true" src={group} alt="객실아이콘" />
            <span>{t("txt_max_guests_bk")}</span>
            <span className="wrap-text">
              &nbsp;&nbsp;{rmPdInf?.minPerCt}
              {t("txt_ppl")}&nbsp;/&nbsp;{t("txt_mxm_bk")}
              {rmPdInf?.maxPerCt}
            </span>
          </li>
        </ul>
        <div ref={rmDescRef}></div>
      </div>

      {/* 숙소편의시설 */}
      {lodOpList.length !== 0 && (
        <div className="mt-6 md:mt-10">
          <h4>{t("sb_ttl_md_fcl_bk")}</h4>
          {lodOpList &&
            lodOpList.map((item: any) => {
              return (
                <ul>
                  <li>{/* <span>{item}</span> */}</li>
                </ul>
              );
            })}
        </div>
      )}

      {/* 객실편의 시설 */}
      {rmOpList.length !== 0 && (
        <div className="mt-6 md:mt-10">
          <h4>{t("sb_ttl_md_pck_bk")}</h4>
          <ul>
            {rmOpList.map((op: any) => {
              return <li></li>;
            })}
          </ul>
        </div>
      )}

      {/* 패키지 예약 */}

      <div className="package my-6 md:mt-10">
        <Package packageList={packageList} type="modal" rmPdNo={rmPdNo} />
      </div>

      {isLoading && <Loading />}
    </div>
  );
}
